import React, { useLayoutEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withLayout from 'hoc/withLayout';
import LoginPage from 'routes/LoginPage/LoginPage';
import ResourcePage from 'routes/ResourcePage/ResourcePage';
import SettingsPage from 'routes/SettingsPage/SettingsPage';
import Page404 from 'routes/Page404/Page404';
import { ROUTER_PATHS } from 'routes/routerConstants';
import { useSetRecoilState } from 'recoil';
import { hasPermission } from 'utils';
import { ProjectPage } from '../../routes/ProjectPage/ProjectPage';
import { codeState } from '../../store/atoms';

const App = () => {
  const setCode = useSetRecoilState(codeState);

  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      setCode(code);
    }
  }, []);
  return (
    <Routes>
      <Route
        path={ROUTER_PATHS.ROOT}
        element={
          <Navigate
            to={
              hasPermission('resource_view.read')
                ? ROUTER_PATHS.RESOURCES
                : ROUTER_PATHS.LOGIN
            }
          />
        }
        exact
      />
      <Route
        path={ROUTER_PATHS.LOGIN}
        element={withLayout(LoginPage)()}
        exact
      />
      <Route
        path={ROUTER_PATHS.RESOURCES}
        element={
          hasPermission('resource_view.read') ? (
            withLayout(ResourcePage, true)()
          ) : (
            <Navigate to={ROUTER_PATHS.ROOT} replace />
          )
        }
        exact
      />
      <Route
        path={ROUTER_PATHS.PROJECTS}
        element={
          hasPermission('project_view.read') ? (
            withLayout(ProjectPage, true)()
          ) : (
            <Navigate to={ROUTER_PATHS.ROOT} replace />
          )
        }
        exact
      />
      <Route
        path={ROUTER_PATHS.SETTINGS}
        element={
          hasPermission('settings.read') ? (
            withLayout(SettingsPage, true)()
          ) : (
            <Navigate to={ROUTER_PATHS.ROOT} replace />
          )
        }
        exact
      />
      <Route path={ROUTER_PATHS.NOT_FOUND} element={<Page404 />} exact />
      <Route path="*" element={<Navigate to={ROUTER_PATHS.NOT_FOUND} />} />
    </Routes>
  );
};

export default App;
